import { render, staticRenderFns } from "./InviaMail.vue?vue&type=template&id=1e5b0749&scoped=true&"
import script from "./InviaMail.vue?vue&type=script&lang=js&"
export * from "./InviaMail.vue?vue&type=script&lang=js&"
import style0 from "./InviaMail.vue?vue&type=style&index=0&id=1e5b0749&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5b0749",
  null
  
)

export default component.exports